import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { expenseEndpoints } from '@/lib/api/endpoints';
import { expenseKeys } from '@/lib/queryKeys';
import type { Expense } from '@/types/settings';

export function useRejectExpense(jobId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<Expense, { id: string; reason?: string }>({
    mutationFn: ({ id, reason }) =>
      apiPost<Expense>(operationsClient, expenseEndpoints.reject(id), { reason }),
    onSuccess: (_expense, variables) => {
      void queryClient.invalidateQueries({ queryKey: expenseKeys.byJob(jobId) });
      void queryClient.invalidateQueries({ queryKey: expenseKeys.detail(variables.id) });
      void queryClient.invalidateQueries({ queryKey: expenseKeys.profitability(jobId) });
      toast.success('Expense rejected');
    },
  });
}
